module.exports = __webpack_public_path__ + "img/career5.fceb07aa.jpg";